"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _api = require("@focaltec-suite/api");
var _NotificationsMenu = _interopRequireDefault(require("./NotificationsMenu"));
var _NotificationViewer = _interopRequireDefault(require("./NotificationViewer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function NotificationsList() {
  var _a;
  var qs = (0, _reactRouterDom.useLocation)().search;
  var query = (0, _react.useMemo)(function () {
    return new URLSearchParams(qs);
  }, [qs]);
  var params = (0, _commons.useSearchParams)(query);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var tenantId = (_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id;
  var _useState = (0, _react.useState)('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedNotifications = _useState6[0],
    setSelectedNotifications = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    notification = _useState8[0],
    setNotification = _useState8[1];
  var clearCallback = (0, _react.useCallback)(function () {
    return setData(undefined);
  }, []);
  var _usePagination = (0, _commons.usePagination)(clearCallback),
    page = _usePagination.page,
    pageSize = _usePagination.pageSize,
    onChangedPage = _usePagination.onChangedPage,
    onChangedPageSize = _usePagination.onChangedPageSize;
  var retrievePromise = (0, _react.useCallback)(function () {
    var offset = (0, _commons.getOffset)(page, pageSize);
    return (0, _api.listNotifications)(Object.assign(Object.assign({}, params), {
      page: pageSize,
      offset: offset,
      tenantId: tenantId
    }), {
      access: access
    });
  }, [page, pageSize, params, tenantId, access]);
  var reload = (0, _react.useCallback)(function () {
    setData(undefined);
    setStatus('loading');
    retrievePromise().then(function (response) {
      setData(response);
      setStatus('loaded');
    })["catch"](function (error) {
      setStatus(error);
    });
  }, [retrievePromise]);
  (0, _react.useEffect)(reload, [reload]);
  var onClicked = (0, _react.useCallback)(function (notification) {
    setNotification(notification);
  }, []);
  var onUpdated = (0, _react.useCallback)(function () {
    setSelectedNotifications([]);
    reload();
  }, [reload]);
  var onUpdatedRead = (0, _react.useCallback)(function (notification) {
    setData(function (curr) {
      if (!curr) return;
      var newNotifications = curr.items.map(function (el) {
        return el.id === notification.id ? notification : el;
      });
      return Object.assign(Object.assign({}, curr), {
        items: newNotifications
      });
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_commons.Pagination, {
    title: (0, _core.translate)('notifications.title'),
    icon: /*#__PURE__*/_react["default"].createElement(_commons.NotificationsIcon, null),
    page: page,
    pageSize: pageSize,
    count: data ? data.items.length : 0,
    total: data ? data.count : 0,
    onChangedPage: onChangedPage,
    onChangedPageSize: onChangedPageSize,
    ellipsisBuilder: function ellipsisBuilder() {
      return /*#__PURE__*/_react["default"].createElement(_NotificationsMenu["default"], {
        notifications: selectedNotifications,
        onMarkedAsRead: onUpdated,
        onDeleted: onUpdated
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.SearchFilter, {
    label: (0, _core.translate)('notifications.filter'),
    query: query
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mx: -2,
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null), /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
    items: data ? data.items : [],
    loading: status === 'loading',
    error: status instanceof Error ? status.message : undefined,
    empty: (0, _core.translate)('notifications.empty'),
    getId: function getId(notification) {
      return notification.id;
    },
    clickable: {
      onClick: onClicked
    },
    refreshable: {
      columnId: 'actions',
      onClick: reload
    },
    selectable: {
      selected: selectedNotifications,
      onChange: function onChange(ids, items) {
        setSelectedNotifications(ids);
      }
    },
    columns: [{
      title: (0, _core.translate)('notifications.subject'),
      converter: function converter(notification) {
        return /*#__PURE__*/_react["default"].createElement(_commons.Ellipsis, {
          text: notification.subject,
          lenght: 30
        });
      },
      id: 'id',
      fixed: 'left',
      width: 240
    }, {
      title: (0, _core.translate)('notifications.text'),
      converter: function converter(notification) {
        return "".concat(notification.text.substring(0, 200), "...");
      },
      id: 'text',
      wordWrapEnabled: true
    }, {
      title: (0, _core.translate)('notifications.created_at'),
      converter: function converter(notification) {
        return (0, _commons.formatDateTime)({
          date: notification.created_at
        });
      },
      id: 'created_at',
      width: 180
    }]
  }), notification && /*#__PURE__*/_react["default"].createElement(_NotificationViewer["default"], {
    notification: notification,
    onUpdated: onUpdatedRead,
    onClose: function onClose() {
      return setNotification(undefined);
    }
  })));
}
var _default = exports["default"] = NotificationsList;